import API from "../../api/authservice";
import router from "../../router/index";
import _ from "lodash";
// import { Object } from "core-js";

const state = {
  token: window.sessionStorage.getItem("auth_token") || "",
  errors: [],
  notifications: [],
};
const getters = {
  isLoggedIn: (state) => !!state.token,
  getToken: (state) => state.token,
  notifications: (state) => state.notifications,
  getErrors: (state) => state.errors,
};
const actions = {};
const mutations = {};
export default {
  state,
  getters,
  actions,
  mutations,
};
